
export default {
  simplePlaceSearch: {
    'noPlaceFound': 'No se ha encontrado nigun lugar para el contenido insertado',
    'openSidebarToSeeRouteDetails': 'Abra la barra lateral para ver los detalles',
    'unknownSearchPlaceError': 'Error desconocido en la búsqueda de lugar'
  }
}
